export const getParams: any = async () => {
	const params: any = await new Proxy(
		new URLSearchParams(window.location.search),
		{
			get: (searchParams, prop: any) => searchParams.get(prop),
		},
	)

	return params
}

export const getPathName: any = () => {
	const { pathname } = window.location
	return pathname.split('/')[1]
}

export const transformOrder = async (orderDecoded: any) => {
	const { order, deviceToken, credentials } = orderDecoded

	return {
		order: {
			value: order.value,
			currency: order.currency,
			validity: order.validity,
			valueWithDiscount: order.value,
			discountPercentage: 0,
			items: [
				{
					plan: order.name,
					type: 'upgrade',
					reference: '',
				},
			],
		},
		deviceToken,
		credentials,
	}
}
